import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-CA-logo_svg__svg2",
  viewBox: "0 0 135.83 149.49"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-CA-logo_svg__cls-1{fill-rule:evenodd;fill:#ed1c24}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      id: "svg-CA-logo_svg__path2446",
      d: "M4.63 54.12c3.6-.23 6.55 2.33 7.21 5.67v44.33c-.08 12.56 10.03 22.69 22.64 22.68 12.33 0 22.44-10.12 22.63-22.68V72.16c-.24-24.36 19.47-44.09 43.74-44.32 17.14-.12 31.17-11.82 34.99-27.84-8.81 6.71-20.01 10.95-31.9 10.83-2.36.12-2.11.25-4.12 0h.51c-34.07 0-61.06 27.24-61.22 61.33v29.9-.51c-.02.24-.02.24 0 .51-.02 3.04-2.68 5.7-6.17 5.67-3.06.03-5.73-2.64-5.66-5.67-.06-.26-.06-.28 0-.51V60.31c-.06-4.16-3.24-7.36-7.2-7.22.34-2.36 2.33-4.13 4.63-4.13.86 0 1.58.17 2.06.52 1 .23 2.12.4 3.09.51 6.45-.11 11.52-5.19 11.32-11.34.2-.24.19-.37 0-.51-2.4 3.28-6.51 5.46-11.32 5.67-.6-.43-1.76-.42-2.58-.52-5.31.1-9.59 4.38-9.77 9.79H0v1.03h5.15-.52",
      class: "svg-CA-logo_svg__cls-1"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      id: "svg-CA-logo_svg__path2448",
      d: "M100.84 48.45C87.74 48.33 77.09 59 77.17 72.16v-.51 37.11c-.09 18.29-14.66 33-32.93 32.99-12.67 0-23.77-7.36-29.33-18.04 4.99 4.77 11.84 7.86 19.55 7.73 14.95.13 27.19-12.14 27.27-27.32V72.16c-.06-21.69 17.49-39.26 39.1-39.18H99.8c11.61-.09 22.11-4.84 29.84-12.37-1.22 15.45-14.14 27.72-29.84 27.84h1.03",
      class: "svg-CA-logo_svg__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      id: "svg-CA-logo_svg__path2450",
      d: "M95.18 82.99c-.17-3.47 2.45-6.1 5.66-6.18 3.28.08 5.9 2.71 5.66 6.18.24.48.12 1.16 0 1.55-.32 1.2-1.49 2.22-3.08 2.07-1.37.15-2.63-1.12-2.58-2.58-.05-.5.02-.87 0-1.04v-.51c-.36 1.36-.6 2.58-.52 3.6-.08 5.93 4.52 10.54 10.29 10.31 4.02.23 7.57-2.2 9.26-5.66 1.41-2.64 2.26-5.79 2.05-9.28.21-10.97-8.79-19.99-20.06-20.1-10.97.11-19.97 9.13-20.07 20.1v27.32c0 20.84-16.75 37.62-37.56 37.63-2.76-.01-5.61-.35-8.23-1.03h-.51c5.24 2.48 11.35 3.96 18.01 4.12 22.76-.16 41.39-18.82 41.16-41.75V82.48l.51.51",
      style: {"fill":"#ed1c24"}
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "CA-logo"}) } }